var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9372 2.22663L14.676 4.92218C14.9506 5.3462 15.5607 5.77022 16.0183 5.89136L19.13 6.67883C21.0519 7.16342 21.5705 8.79892 20.3198 10.3133L18.2758 12.7665C17.9707 13.1603 17.7267 13.8569 17.7572 14.3415L17.9402 17.5216C18.0623 19.4903 16.659 20.4897 14.8286 19.7629L11.8389 18.5817C11.3813 18.3999 10.6187 18.3999 10.1611 18.5817L7.17143 19.7629C5.34103 20.4897 3.93773 19.46 4.05976 17.5216L4.2428 14.3415C4.2733 13.8569 4.02925 13.13 3.72418 12.7665L1.68024 10.3133C0.429475 8.79892 0.948088 7.16342 2.87 6.67883L5.98167 5.89136C6.46978 5.77022 7.07991 5.31591 7.32396 4.92218L9.06283 2.22663C10.1611 0.591124 11.8694 0.591124 12.9372 2.22663Z",
    stroke: "#BFFF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree1);
export default __webpack_public_path__ + "static/media/three1.0f320f591ddf797723847b2b9fd28ab1.svg";
export { ForwardRef as ReactComponent };